import { create } from 'zustand'

interface UIState {
    isSidebarOpen: boolean
    isMobileSidebarOpen: boolean
    toggleSidebar: () => void
    toggleMobileSidebar: () => void
    closeMobileSidebar: () => void
}

export const useUIStore = create<UIState>(set => ({
    isSidebarOpen: true,
    isMobileSidebarOpen: false,
    toggleSidebar: () =>
        set(state => ({ isSidebarOpen: !state.isSidebarOpen })),
    toggleMobileSidebar: () =>
        set(state => ({ isMobileSidebarOpen: !state.isMobileSidebarOpen })),
    closeMobileSidebar: () => set({ isMobileSidebarOpen: false }),
}))
